import React, {Component} from 'react';
import {translate} from 'react-i18next';
import Form from './components/Form';
import RaisedButton from 'material-ui/RaisedButton';
import Notifications, {notify} from 'react-notify-toast';
import swal from 'sweetalert';
import WaitingModal from '../../generics/WaitingModal';
import moment from 'moment';


var Config = require('../../../config');

class Cryoprecipitate extends Component{
	constructor(props){
		super(props);

		this.onSave = this.onSave.bind(this);
		this.onReturn = this.onReturn.bind(this);
		this.clear = this.clear.bind(this);

		this.state = {
			bntNew: false
		}
	}

	componentDidMount(){
	}

	onSave(){
		if (this.isValidDate(this.form.state.date)){
			if(this.isValidForm()){			
				var parts = this.form.getCryoData();
				if(parts.cryoprecipitate_parts.length === 0){
					notify.show('Error, Tabla incompleta','error');

				}else if(parts.error_lock !== undefined){
					swal('Error', 'No es posible realizar el proceso debido a que las unidades '+parts.error_lock+' se encuentran bloqueadas', 'error');
				
				}else if(parts.cryoprecipitate_parts === 'error_valor' ){
					swal('Error', 'Debe ingresar un volumen mayor a cero en todos los componentes.', 'error');
				
				}else if(parts.hour === "Invalid date"){
					notify.show('Error, Hora invalida', 'error');
				
				}else if(parts.error_vol !== ""){
					swal({
				        title: '¿Está seguro?',
				        text: 'La suma de las unidades resultantes de las unidades '+parts.error_vol+
				        	  ' es diferente al de la unidad original. ¿Desea continuar?'	,
				        type: 'warning',
				        showCancelButton: true,
				        confirmButtonColor: '#DD6B55',
				        confirmButtonText: '¡Si, Guardar!',
				        cancelButtonText: '¡No, Cancelar!',
				        closeOnConfirm: true,
				        closeOnCancel: true
				    }, function (isConfirm) {
				        if (isConfirm) {
				        	delete parts.error_vol;
				          	this.saving(parts);
				        }
				    }.bind(this));
				}else{
					this.saving(parts);
				}
			}else {
		    	notify.show('Error, Campos Incompletos','error');
		    }
		}else{
			notify.show('Error, Fecha no válida','error');			
		}
	}

	clear(){
		this.form.setState({
			cryoprecipitates:[],
			parts:[],
			units:[],
			search:'date',
			unit_number:"",
			component:"",
			pending:true,
		})

		this.setState({
			bntNew: false
		})
	}

	isValidDate(fecha){
		var valid = moment(fecha).format('MM-DD-YYYY');

		if(valid === 'Invalid date'){
			return false;
		}else{
			return true;
		}
	}

	saving(obj){
		obj.health_facilities_id = sessionStorage.getItem('health_facilities_id');
		
		this.waiting_modal.handleShow('Guardando...');
		fetch(Config.default.apiGateway.URL+'cryoprecipitate_process', {
			method : 'post',
			body: JSON.stringify(obj),
			headers : new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem("token"),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		})
		.then(res => {
			this.waiting_modal.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then(function(result){
					swal("Error", result, 'error');
				})
			}
		})
		.then(response => {
			if(response !== undefined){
				if(response.Message !== undefined){
					swal('Error', response.ExceptionMessage, 'error');
				}else{
					swal('¡Buen Trabajo!', "Proceso Terminado", 'success');
					
					//this.props.history.push("/cryoprecipitate_list");
					
					this.form.setState({
						units: response.unit_ids !== null ? response.unit_ids : [],
						pending:false
					});

					this.setState({bntNew: true});
				}
					
			}
		});

		

	}

	isValidForm(){
		const inputs = document.querySelectorAll('select, input');
		let isFormValid = true;

		inputs.forEach(input => {
			if(input.required){
				const isInputValid = this.form.showCtrlError(input.name);
				if(!isInputValid){
					isFormValid = false;
				}
			}
		});

		return isFormValid;
	}

	onReturn(){
		this.props.history.push('/cryoprecipitate_list');
	}

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{sessionStorage.getItem('health_facilities_name')} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.cryoprecipitate.MAIN')}
					</h5>
				</div>
				
				<form noValidate>
					<Form {...this.props} onRef={ref => (this.form = ref)} />
					<Notifications />
				</form>

				<div className="col-xs-12" style={{textAlign:'center'}}>
		        	<div>
						<RaisedButton className="action-btn" 
							label={!this.state.bntNew ? t('content.generics.buttons.save') : t('content.generics.buttons.new')} primary={true} 
							onClick={!this.state.bntNew ? this.onSave : this.clear} 
							style={{margin:12}}/>
		        		<RaisedButton className="action-btn" label={t('content.generics.buttons.return')} primary={true} style={{margin:12}} onClick={this.onReturn}/>
		        	</div>
		        </div>

		        <WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
			</div>
		)
	}
}

export default translate('translations')(Cryoprecipitate);
